import { render, staticRenderFns } from "./ModalDocumento.vue?vue&type=template&id=70d0c18a&scoped=true"
import script from "./ModalDocumento.vue?vue&type=script&lang=js"
export * from "./ModalDocumento.vue?vue&type=script&lang=js"
import style0 from "./ModalDocumento.vue?vue&type=style&index=0&id=70d0c18a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d0c18a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d0c18a')) {
      api.createRecord('70d0c18a', component.options)
    } else {
      api.reload('70d0c18a', component.options)
    }
    module.hot.accept("./ModalDocumento.vue?vue&type=template&id=70d0c18a&scoped=true", function () {
      api.rerender('70d0c18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/infoBase/modales/ModalDocumento.vue"
export default component.exports